export default "__VITE_ASSET__CF$od9s3__"